import { Action } from '@ngrx/store';

export interface AppAction extends Action {
  type: string;
  payload?: any;
}

export const AppActions = {
  IDOLS_FETCH: '[Idols] Fetch',
  IDOLS_FETCH_SUCCESS: '[Idols] Fetch Success',
  SETTINGS_FETCH: '[Settings] Fetch',
  SETTINGS_FETCH_SUCCESS: '[Settings] Fetch Success',
  TOKENS_FETCH: '[Tokens] Fetch',
  TOKENS_FETCH_SUCCESS: '[Tokens] Fetch Success',
  USER_FETCH: '[User] Fetch',
  USER_FETCH_SUCCESS: '[User] Fetch Success',
  USERS_FETCH: '[Users] Fetch',
  USERS_FETCH_SUCCESS: '[Users] Fetch Success',
  WALLET_FETCH: '[Wallet] Fetch',
  WALLET_FETCH_SUCCESS: '[Wallet] Fetch Success'
};

export class IdolsFetchAction implements AppAction {
  readonly type: string = AppActions.IDOLS_FETCH;
}

export class IdolsFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.IDOLS_FETCH_SUCCESS;
  constructor(public payload: object[] | null) {}
}

export class SettingsFetchAction implements AppAction {
  readonly type: string = AppActions.SETTINGS_FETCH;
  constructor(public payload: string) {}
}

export class SettingsFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.SETTINGS_FETCH_SUCCESS;
  constructor(public payload: object | null) {}
}

export class TokensFetchAction implements AppAction {
  readonly type: string = AppActions.TOKENS_FETCH;
}

export class TokensFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.TOKENS_FETCH_SUCCESS;
  constructor(public payload: object[] | null) {}
}

export class UserFetchAction implements AppAction {
  readonly type: string = AppActions.USER_FETCH;
}

export class UserFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.USER_FETCH_SUCCESS;
  constructor(public payload: object | null) {}
}

export class UsersFetchAction implements AppAction {
  readonly type: string = AppActions.USERS_FETCH;
}

export class UsersFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.USERS_FETCH_SUCCESS;
  constructor(public payload: object[]) {}
}

export class WalletFetchAction implements AppAction {
  readonly type: string = AppActions.WALLET_FETCH;
  constructor(public payload: object | null) {}
}

export class WalletFetchSuccessAction implements AppAction {
  readonly type: string = AppActions.WALLET_FETCH_SUCCESS;
  constructor(public payload: object | null) {}
}



// WEBPACK FOOTER //
// ./src/app/app.actions.ts